export const ATE_AGENCY_ID = '9f00a714-eb40-4748-8af1-392b0e81e7b0';
